// src/pages/InterviewPrepDetail.jsx
import React, { useEffect, useState } from "react";
import { db } from "./firebase/firebaseConfig";
import {
  collection,
  getDocs,
  query,
  orderBy,
  doc,
  getDoc,
  deleteDoc,
} from "firebase/firestore";
import { useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 40px;
  color: #fff;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.05);
  padding: 20px;
  border-radius: 10px;
  cursor: pointer;
`;

const AddButton = styled.button`
  background: linear-gradient(135deg, #00d4ff, #00bcd4);
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  color: #121212;
  font-weight: bold;
  margin-bottom: 20px;
  cursor: pointer;
`;

const DeleteButton = styled.button`
  margin-top: 10px;
  background: #ff4d4f;
  border: none;
  padding: 6px 10px;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
`;

const InterviewPrepDetail = () => {
  const { prepId } = useParams();
  const [modules, setModules] = useState([]);
  const [prep, setPrep] = useState(null);
  const navigate = useNavigate();

  // ✅ Fetch prep
  const fetchPrep = async () => {
    try {
      const docRef = doc(db, "interviewPreps", prepId);
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        setPrep({ id: snap.id, ...snap.data() });
      }
    } catch (error) {
      console.error(error);
    }
  };

  // ✅ Fetch modules (renamed from topics)
  const fetchModules = async () => {
    try {
      const q = query(
        collection(db, `interviewPreps/${prepId}/modules`), // 🔥 changed
        orderBy("createdAt", "desc")
      );
      const snap = await getDocs(q);
      setModules(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (error) {
      console.error("Error fetching modules:", error);
    }
  };

  // ✅ Delete module
  const handleDelete = async (moduleId) => {
    const confirmDelete = window.confirm("Delete this module?");
    if (!confirmDelete) return;

    try {
      await deleteDoc(
        doc(db, `interviewPreps/${prepId}/modules`, moduleId) // 🔥 changed
      );
      setModules((prev) => prev.filter((m) => m.id !== moduleId));
    } catch (error) {
      console.error("Error deleting module:", error);
    }
  };

  useEffect(() => {
    fetchPrep();
    fetchModules();
  }, []);

  return (
    <Wrapper>
      <h2>{prep?.title || "Interview Prep"}</h2>

      <AddButton onClick={() => navigate(`/add-module/${prepId}`)}>
        ➕ Add Module
      </AddButton>

      <Grid>
        {modules.map((module) => (
          <Card key={module.id}>
            <h3>{module.title}</h3>

            <small style={{ color: "#aaa" }}>
              {module.createdAt?.toDate().toLocaleString()}
            </small>

            {/* 👇 View Button */}
            <button
              onClick={() => navigate(`/module-detail/${prepId}/${module.id}`)}
              style={{
                marginTop: "10px",
                background: "#00d4ff",
                border: "none",
                padding: "6px 10px",
                borderRadius: "6px",
                color: "#121212",
                cursor: "pointer",
                marginRight: "8px",
              }}
            >
              👁 View
            </button>

            {/* Delete */}
            <DeleteButton
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(module.id);
              }}
            >
              🗑 Delete
            </DeleteButton>
          </Card>
        ))}
      </Grid>
    </Wrapper>
  );
};

export default InterviewPrepDetail;
